export enum NOTIFICATION_STATUS_CODE {
    DISP = 'DISP',
    ETA = 'ETA',
    DURA = 'DURA',
    REMT = 'REMT',
    ROSR = 'ROSR',
    FCC = 'FCC',
    TRAV = 'TRAV',
    OSR = 'OSR',
    SOSR = 'SOSR', // SOSR: Special OSR for PACE US
    CRM = 'CRM',
    SCRM = 'SCRM',
    AVR1 = 'AVR1',
    AVR2 = 'AVR2',
    AVRF = 'AVRF',
    CANC = 'CANC',
    BREK = 'BREK',
    WAIT = 'WAIT',
    // This is an internal statusCode to indicate that the notification is ready to be signed.
    // It implies that a different notification can be put to TRAV and higher
    TOBS = 'TOBS',
    // for handling whats new status sms
    ADA = 'ADA',
    REFR = 'REFR',
    // new internal status to track if user has acknowledge
    CNCL = 'CNCL',
    // Need RTOBS If Remote Work/Training(ROSR) to be signed,
    // Need FTOBS If Remote Support(FCC) to be signed,
    // RTOBS and FTOBS: Remote work/ Remote support to be signed, this is an internal statusCode to indicate that selected is Remote work status and is ready to be signed.
    // Used in time recording work type dropdown is filtered based on ROSR or FCC
    RTOBS = 'RTOBS',
    FTOBS = 'FTOBS',
    ATS = 'ATS', // Safety Assessment Form
}

export enum STATUS_STEP_FOR_REMOTE_WORK {
    DISP = 'DISP',
    ETA = 'ETA',
    REMT = 'REMT',
    ROSR = 'ROSR',
    FCC = 'FCC',
    SCRM = 'SCRM',
    CRM = 'CRM',
    ESCALATE = 'ESCALATE',
    FORMS = 'FORMS',
    TRAV = 'TRAV',
    OSR = 'OSR',
}
export enum STATUS_STEP_FOR_NON_REMOTE_WORK {
    DISP = 'DISP',
    ETA = 'ETA',
    TRAV = 'TRAV',
    ATS = 'ATS',
    OSR = 'OSR',
    SCRM = 'SCRM',
    CRM = 'CRM',
    ESCALATE = 'ESCALATE',
    FORMS = 'FORMS',
    ROSR = 'ROSR',
    FCC = 'FCC',
}
